import React, { useEffect } from "react";
import { connect, useStore } from "react-redux";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import { RAGE_RIGHT } from "../utils/enums/RAGE_RIGHT";
import { checkResize, checkRageRightByProps } from "../utils/functions";
import MALogin from "../Mitarbeiter/MALogin";
import WhiteLabel from "../whiteLabel/whiteLabel";
import MenuAndContact from "../menuAndContact";
import Conditions from "../konditionen/conditions";
import Timeout from "../utils/components/Timeout";
import Auftraege from "../auftraege/Auftraege";
import Kursliste from "../kursliste/Kursliste";
import { useSearch } from "../utils/components/router";
import Lieferadressen from "../lieferadressen/Lieferadressen";
import Auftragsobergrenze from "./Auftragsobergrenze";

const Administration = ({ requiredRageRight }) => {
  const { configStorage, rightStorage, mandantStorage } = useStore().getState();
  const { active, select } = useSearch();
  const canOpenAdminTabs = rightStorage.isAdmin() || configStorage.isBLBAdmin();

  //console.info("isAdmin", rightStorage.isAdmin());
  //console.info("isBLBAdmin", configStorage.isBLBAdmin());
  //console.info("canOpenAdminTabs", canOpenAdminTabs);

  useEffect(() => {
    checkResize();
  }, []);

  if (!checkRageRightByProps({ rightStorage, requiredRageRight })) {
    return (
      <MALogin redirect={false} title="Verwaltungsfunktionen" />
    );
  }

  let activeKey;
  switch (active) {
    case "whitelabel":
      activeKey = canOpenAdminTabs ? "whitelabel" : "auftraege";
      break;
    case "konditionen":
      if (mandantStorage.hasKonditionen()) {
        activeKey = "konditionen";
      } else
        activeKey = "auftraege";
      break;
    case "auftraege":
      activeKey = "auftraege";
      break;
    case "kursliste":
      activeKey = "kursliste";
      break;
    case "lieferadressen":
      activeKey = "lieferadressen";
      break;
    case "auftragsobergrenze":
      activeKey = canOpenAdminTabs ? "auftragsobergrenze" : "auftraege";
      break;
    default:
      if (canOpenAdminTabs)
        activeKey = "whitelabel";
      else if (mandantStorage.hasKonditionen()) {
        activeKey = "konditionen";
      } else
        activeKey = "auftraege";
      break;
  }

  const shopListe = configStorage.getShopListe();
  let kursListeHeaderText = "Kurs-/Preislisten";
  if (shopListe.length === 1 && shopListe[0] === "edelmetall") kursListeHeaderText = "Preisliste";
  if (shopListe.length === 1 && shopListe[0] === "sorten") kursListeHeaderText = "Kursliste";

  return (
    <section className="if6_outer section if6_section">
      <div className="bootstrap-iso if6_inner p-0">
        <div className="container mt-two p-0">
          <Timeout className="row"></Timeout>
          <Tabs
            defaultActiveKey={activeKey}
            mountOnEnter={true}
            unmountOnExit={true}
          >
            {canOpenAdminTabs
              ? < Tab
                className="p-one bg-white border border-top-0"
                eventKey="whitelabel"
                title="Administration"
              >
                <WhiteLabel />
              </Tab>
              : null
            }
            {canOpenAdminTabs
              ? < Tab
                className="p-one bg-white border border-top-0"
                eventKey="lieferadressen"
                title="Lieferadressen"
              >
                <Lieferadressen />
              </Tab>
              : null
            }
            {mandantStorage.hasKonditionen() || canOpenAdminTabs
              ? < Tab
                className="p-one bg-white border border-top-0"
                eventKey="konditionen"
                title="Konditionsänderung"
              >
                <Conditions />
              </Tab>
              : null
            }
            {canOpenAdminTabs
              ? <Tab
                className="p-one bg-white border border-top-0"
                eventKey="auftragsobergrenze"
                title="Obergrenze"
              >
                <Auftragsobergrenze />
              </Tab>
              : null
            }
            <Tab
              className="p-one bg-white border border-top-0"
              eventKey="auftraege"
              title="Auftragsübersicht"
            >
              <Auftraege />
            </Tab>
            <Tab
              className="p-one bg-white border border-top-0"
              eventKey="kursliste"
              title={kursListeHeaderText}
            >
              <Kursliste select={select} />
            </Tab>
          </Tabs>
        </div>
      </div >
      {configStorage.hasMenu()
        ? <MenuAndContact />
        : null
      }
    </section >
  );
};

export default connect(() => {
  return {
    // wird noch benötigt, weil AuftragTabelle sonst nicht neu gerendert wird, warum auch immer React das braucht
    requiredRageRight: [RAGE_RIGHT.RAGE_ADMIN, RAGE_RIGHT.RAGE_BERATER_EINS, RAGE_RIGHT.RAGE_BERATER_ZWEI]
  };
})(Administration);
